import { useState } from 'react';
import automobyApi from '../Api';
import { useUpdateEffect } from './useUpdateEffect';

export const useTransportPrice = (defaultPageSize) => {
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0); 
  const [filter, setFilter] = useState({
    all: true,
    limit: defaultPageSize,
    order_by: "id",
    page: 1,
    sender_country_id: 0,
    reciever_country_id: 0,
    sender_city_id: 0,
    reciever_city_id: 0,
    is_active: true,
    name: "", 
  });

  useUpdateEffect(() => {
    fetchList();
  }, [filter]);
 
  const fetchList = async () => {
    try {
      const response = await automobyApi.post("/transport/price/list", filter)
      setItems(response.data.transport_prices);
      setTotal(response.data.total);
      return response.data.transport_prices
    } catch (error) { 
      console.error("თუ ერორია:" + error);
    }
  }

  const fetch = async () => {
    try {
      const requestData = {
        all: true,
        limit: 100,
        order_by: "id",
        offset: 1
      };

      const response = await automobyApi.post("/transport/price/all", requestData)
      setItems(response.data.transport_prices);
      setTotal(response.data.total);
      return response.data.transport_prices
    } catch (error) {

      console.error("თუ ერორია:" + error);
    }
  }

  const add = async (newData) => {
    try {
      const response = await automobyApi.post(`/transport/price/create`, newData);
      fetchList();
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  const addone = async (newData) => {
    try {
      const response = await automobyApi.post(`/transport/price/addone`, newData);
      fetchList();
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  const search = async (transportPrice, count) => {
    try {
      const requestData = {
        transportPrice: transportPrice,
        count: count,
      };

      const response = await automobyApi.post("/transport/price/search", requestData)
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  const update = async (newData) => {
    try {
      const response = await automobyApi.post(`/transport/price/update`, newData);
      fetchList();
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  const remove = (id) => {
    return new Promise(async (resolve, reject) => {
      try {
        const requestData = {
          transport_price_id: id
        };
        const response = await automobyApi.post(`/transport/price/delete`, requestData);
        fetchList();
        resolve(response);
      } catch (error) {
        reject(error);
      }
    });
  } 

  const getTransportPrice = (senderCityId, recieverCityId) => {
    return new Promise(async (resolve, reject) => {
      try {
        const requestData = {
          sender_city_id: senderCityId,
          reciever_city_id: recieverCityId 
        };
        const response = await automobyApi.post(`/transport/price/get`, requestData);
        resolve(response.data);
      } catch (error) {
        reject(error);
      }
    });
  } 

  const downloadExcel = (id, name) => {
    automobyApi({
      url: `/transport/price/excel`,
      method: 'POST',
      responseType: 'blob',
      data: filter
    })
    .then((response) => {
      const currentDate = new Date();
      const formattedDate = `${currentDate.getFullYear()}-${currentDate.getMonth() + 1}-${currentDate.getDate()}`;
      const formattedTime = `${currentDate.getHours()}-${currentDate.getMinutes()}-${currentDate.getSeconds()}`;
      const fileName = `excel_${formattedDate}_${formattedTime}.xlsx`;
  
      const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
    })
    .catch((error) => console.error('Download failed:', error));
  };

  const massDelete = async (ids) => {
    try {
      const response = await automobyApi.post('/transport/price/mass-delete', {
        ids: ids
      });
      fetchList();
      return response.data;
    } catch (error) {
      console.error('Mass delete error:', error);
      throw error;
    }
  };

  const massArchive = async (ids) => {
    try {
      const response = await automobyApi.post('/transport/price/mass-archive', {
        ids: ids
      });
      fetchList();
      return response.data;
    } catch (error) {
      console.error('Mass archive error:', error);
      throw error;
    }
  };
  
  const transportPriceService = {
    items: items,
    total: total,
    filter: filter, 
    setFilter: setFilter,
    fetch: fetch,
    fetchList: fetchList,
    add: add,
    search: search,
    update: update,
    remove: remove, 
    getTransportPrice: getTransportPrice,
    downloadExcel: downloadExcel,
    addone: addone,
    massDelete: massDelete,
    massArchive: massArchive,
  };

  return { transportPriceService };
}